import z from "zod";
export const DataSourceRemoteType = z.enum([
    "Figma",
    "TokenStudio",
    "FigmaVariablesPlugin",
    "Storybook",
]);
export const DataSourceUploadRemoteSource = z.enum([
    "TokenStudio",
    "FigmaVariablesPlugin",
    "Custom",
]);
export const DataSourceFigmaState = z.enum([
    "Active",
    "MissingIntegration",
    "MissingFileAccess",
    "MissingFileOwner",
]);
export const DataSourceFigmaErrorType = z.enum([
    "FigmaAPIRateLimit",
    "UnknownImportError",
]);
export const DataSourceAutoImportMode = z.enum(["Never", "Hourly"]);
